import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import Translatable from '@/app-core/mixins/translatable'
import {getContrastColor} from '@/app-core/lib/utils/color'
import {toLocaleUpperCase} from '@/app-core/lib/helpers/index.js'

export default {
  name      : 'SelectTagDialog',
  components: {},
  mixins    : [Translatable, DialogVisible, StoreCommon],
  props     : {
    tags: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods : {
    toLocaleUpperCase,
    getContrastColor,
    onTagSelected(tag) {
      this.isVisible = false
      this.$emit('tag:selected', tag)
    },

    onCancelButtonClick() {
      this.isVisible = false
    }
  }
}
